import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/map';
import { Login, OtpModel } from '../model/login';
import { LocalstorageService } from '../../shared/localstorage.service';
import { environment } from '../../../environments/environment.prod';
import { LoginQRData } from '../model/loginQRData';
import * as _swal from 'sweetalert2';
import swal from 'sweetalert2/dist/sweetalert2.js'
import { Observable } from 'rxjs';
import { LocalBodyMaster, Registration } from '../model/registration';

@Injectable()
export class LoginService {

  headers: Headers;
  options: RequestOptions;
  BaseUrl = environment.config.baseUrlDotNet;
  baseUrl = environment.config.baseUrlDhananjoy;
  baseUrl1 = environment.config.baseUrlDhananjoy;

  localStoreElement: string[] = new Array<string>();

  constructor(private _http: Http, private _router: Router, private _cookieService: CookieService,
    private _localStore: LocalstorageService) {
    this.headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  loginUser(userData: Login) {
    console.log("beforelogin", JSON.stringify(userData), this.options);
    return this._http.post(this.BaseUrl + '/Registration/login_v2', userData)
      .map(res => res.json());
  }

  CheckOTPWebsiteLogin(userData: OtpModel) {
    console.log("beforelogin", JSON.stringify(userData), this.options);
    return this._http.post(this.BaseUrl + '/Registration/verifyotpnew_v2', userData)
      .map(res => res.json());
  }

  getNetworkIp(): Observable<string> {
    return this._http.get('https://api.ipify.org?format=json').map((response: Response) => {
      const body = response.json();
      return body.ip;
    });
  }

  logout() {
  swal.fire({
    title: 'Are you sure you want to logout?',
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: `Logout`,
    denyButtonText: `Cancel`,
  }).then(result => {
    let res = [];
    res = result;
    if (res['value'] === true) {
      // Clear localStorage items
      this.localStoreElement = ['rId', 'localBodyId', 'distId', 'localBodyType', 'nominationDate', 'resultDate',
        'userType', 'roleId', 'stateId', 'stateName', 'districtName', 'talukaId', 'talukaName', 'electionType', 
        'paymentStatus', 'year', 'localBodyName', 'localBodyTypeText', 'wardNo', 'wardName', 'address', 'emailId', 
        'firstName', 'middleName', 'lastName', 'electionProgId', 'electionProgramName', 'fullname', 'epDate', 
        'userMobileNo', 'uId', 'token', 'partyName', 'partyType', 'partyNameText', 'partyTypeText', 'typeOfPDF', 
        'predictionId', 'statusOfCompletion', 'statusOfCompletionBooth'];

      this._localStore.destroyLocalStorage(this.localStoreElement);
      
      // Clear ALL sessionStorage
      sessionStorage.clear();
      
      // Also clear cookies if needed
      this._cookieService.deleteAll();
      
      console.log('✅ Logout successful - All storage cleared');
      
      // Navigate to login page
      this._router.navigate(['/login']);
    }
  })
}


  forgotPassword(userMob) {
    return this._http.get(this.BaseUrl + '/Registration/ForgotPassward?userMobileNo=' + userMob)
      .map(res => res.json());
  }

  resendOtp(userMob) {
    return this._http.get(this.BaseUrl + '/Registration/ResendOtp?userMobileNo=' + userMob)
      .map(res => res.json());
  }

  downloadRoleName(userType, RoleId) {
    return this._http.get('https://webapi.truevoter.in/api/DailyExpense/downloadRoleName?userTypeId=' + userType + '&roleId=' + RoleId)
      .map(res => res.json())
  }

  saveLoginQRData(qrData: LoginQRData) {
    return this._http.post(this.BaseUrl + '/Registration/saveqrdata', qrData)
      .map(res => res.json());
  }



  downloadElectionProgBasicDetails(stateId: 27) {
    return this._http
      .get(this.BaseUrl + "/DailyExpense/getelectionprogram?stateId=" + stateId)
      .map((res) => res.json());
  }

  downloadDistrict(stateId: 27) {
    return this._http.get(this.BaseUrl + '/LocalBody/downloaddistrict?stateId=' + stateId)
      .map(res => res.json());
  }

  checkUserVerification(qrData: LoginQRData) {
    return this._http.post(this.BaseUrl + '/Registration/checkVerification', qrData)
      .map(res => res.json());
  }


  getelectionprogram(localbodyType: any) {
    return this._http.get(this.BaseUrl + '/ElectionProgram/downloadEpgmNameBylocalbodyType?localbodyType=' + localbodyType)
      .map(res => res.json());
  }

  loginUserName(userData1: Login) {
    return this._http.post(this.BaseUrl + '/Registration/loginWithNominationUserName', userData1)
      .map(res => res.json());
  }

  getAllLocalBodyMaster(): Observable<any> {
    return this._http.get('https://api.korum.app/api/Auth/get-all-localbodymaster')
      .map(res => res.json());
  }

  /**
   * Check if user exists with given mobile number
   */
  checkUserExists(mobileNo: string): Observable<any> {
    return this._http.get(this.BaseUrl + '/Registration/checkuserexist?userMobileNo=' + mobileNo)
      .map(res => res.json());
  }

  /**
   * Register new user
   */
  registerUser(userData: Registration) {
    console.log("Registration data:", JSON.stringify(userData));
    return this._http.post(this.BaseUrl + '/Registration/register_v2', userData)
      .map(res => res.json());
  }

  /**
   * ✅ NEW: Get Ward Master data (Division and Electoral College)
   * API: https://api.korum.app/api/Auth/get-all-wardMaster?localBodyMasterId=34475
   */
  getWardMaster(localBodyMasterId: number): Observable<any> {
    return this._http.get('https://api.korum.app/api/Auth/get-all-wardMaster?localBodyMasterId=' + localBodyMasterId)
      .map(res => res.json());
  }

}
// import { Injectable } from '@angular/core';
// import { Headers, RequestOptions, Http, Response } from '@angular/http';
// import { Router } from '@angular/router';
// import { CookieService } from 'ngx-cookie-service';
// import 'rxjs/add/operator/map';
// import { Login, OtpModel } from '../model/login';
// import { LocalstorageService } from '../../shared/localstorage.service';
// import { environment } from '../../../environments/environment.prod';
// import { LoginQRData } from '../model/loginQRData';
// import * as _swal from 'sweetalert2';
// import swal from 'sweetalert2/dist/sweetalert2.js'
// import { Observable } from 'rxjs';
// import { LocalBodyMaster, Registration } from '../model/registration';
// // import 'rxjs/add/operator/map';

// @Injectable()
// export class LoginService {

//   headers: Headers;
//   options: RequestOptions;
//   BaseUrl = environment.config.baseUrlDotNet;
//   baseUrl = environment.config.baseUrlDhananjoy;
//   baseUrl1 = environment.config.baseUrlDhananjoy;

//   localStoreElement: string[] = new Array<string>();

//   constructor(private _http: Http, private _router: Router, private _cookieService: CookieService,
//     private _localStore: LocalstorageService) {
//     this.headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
//     this.options = new RequestOptions({ headers: this.headers });
//   }

//   loginUser(userData: Login) {
//     // https://webapi.truevoter.in/api/Registration/login
//     console.log("beforelogin", JSON.stringify(userData), this.options);
//     return this._http.post(this.BaseUrl + '/Registration/login_v2', userData)
//       .map(res => res.json());
//   }

//   CheckOTPWebsiteLogin(userData: OtpModel) {
//     // https://webapi.truevoter.in/api/Registration/login
//     console.log("beforelogin", JSON.stringify(userData), this.options);
//     return this._http.post(this.BaseUrl + '/Registration/verifyotpnew_v2', userData)
//       .map(res => res.json());
//   }

//   getNetworkIp(): Observable<string> {
//     return this._http.get('https://api.ipify.org?format=json').map((response: Response) => {
//       const body = response.json();
//       return body.ip;
//     });
//   }

//   logout() {
//   swal.fire({
//     title: 'Are you sure you want to logout?',
//     showDenyButton: true,
//     showCancelButton: true,
//     confirmButtonText: `Logout`,
//     denyButtonText: `Cancel`,
//   }).then(result => {
//     let res = [];
//     res = result;
//     if (res['value'] === true) {
//       // Clear localStorage items
//       this.localStoreElement = ['rId', 'localBodyId', 'distId', 'localBodyType', 'nominationDate', 'resultDate',
//         'userType', 'roleId', 'stateId', 'stateName', 'districtName', 'talukaId', 'talukaName', 'electionType', 
//         'paymentStatus', 'year', 'localBodyName', 'localBodyTypeText', 'wardNo', 'wardName', 'address', 'emailId', 
//         'firstName', 'middleName', 'lastName', 'electionProgId', 'electionProgramName', 'fullname', 'epDate', 
//         'userMobileNo', 'uId', 'token', 'partyName', 'partyType', 'partyNameText', 'partyTypeText', 'typeOfPDF', 
//         'predictionId', 'statusOfCompletion', 'statusOfCompletionBooth'];

//       this._localStore.destroyLocalStorage(this.localStoreElement);
      
//       // ✅ Clear ALL sessionStorage
//       sessionStorage.clear();
      
//       // ✅ Also clear cookies if needed
//       this._cookieService.deleteAll();
      
//       console.log('✅ Logout successful - All storage cleared');
      
//       // Navigate to login page
//       this._router.navigate(['/login']);
//     }
//   })
// }


//   forgotPassword(userMob) {
//     return this._http.get(this.BaseUrl + '/Registration/ForgotPassward?userMobileNo=' + userMob)
//       .map(res => res.json());
//   }

//   resendOtp(userMob) {
//     return this._http.get(this.BaseUrl + '/Registration/ResendOtp?userMobileNo=' + userMob)
//       .map(res => res.json());
//   }

//   downloadRoleName(userType, RoleId) {
//     return this._http.get('https://webapi.truevoter.in/api/DailyExpense/downloadRoleName?userTypeId=' + userType + '&roleId=' + RoleId)
//       .map(res => res.json())
//   }

//   saveLoginQRData(qrData: LoginQRData) {
//     return this._http.post(this.BaseUrl + '/Registration/saveqrdata', qrData)
//       .map(res => res.json());
//   }



//   downloadElectionProgBasicDetails(stateId: 27) {
//     return this._http
//       .get(this.BaseUrl + "/DailyExpense/getelectionprogram?stateId=" + stateId)
//       .map((res) => res.json());
//   }

//   downloadDistrict(stateId: 27) {


//     // this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
//     // var uid = this.decryptUID.toString(CryptoJS.enc.Utf8);

//     // this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
//     // var token = this.decryptToken.toString(CryptoJS.enc.Utf8);
//     // https://webapi.truevoter.in/api/LocalBody/downloaddistrict?stateId=27
//     return this._http.get(this.BaseUrl + '/LocalBody/downloaddistrict?stateId=' + stateId)
//       .map(res => res.json());
//   }

//   checkUserVerification(qrData: LoginQRData) {
//     // https://webapi.truevoter.in/api/Registration/checkVerification
//     return this._http.post(this.BaseUrl + '/Registration/checkVerification', qrData)
//       .map(res => res.json());
//   }


//   getelectionprogram(localbodyType: any) {
//     return this._http.get(this.BaseUrl + '/ElectionProgram/downloadEpgmNameBylocalbodyType?localbodyType=' + localbodyType)
//       .map(res => res.json());
//   }
//   // download(url: string, filename?: string): Observable<Download> {
//   //   return this._http.get(url, {
//   //     reportProgress: true,
//   //     observe: 'events',
//   //     responseType: 'blob'
//   //   }).pipe(download(blob => this.save(blob, filename)))
//   // }

//   loginUserName(userData1: Login) {
//     return this._http.post(this.BaseUrl + '/Registration/loginWithNominationUserName', userData1)
//       .map(res => res.json());
//   }

//   getAllLocalBodyMaster(): Observable<any> {
//     return this._http.get('https://api.korum.app/api/Auth/get-all-localbodymaster')
//       .map(res => res.json());
//   }

//   /**
//    * Check if user exists with given mobile number
//    * You need to implement this API endpoint on your backend
//    */
//   checkUserExists(mobileNo: string): Observable<any> {
//     // Replace with your actual API endpoint
//     return this._http.get(this.BaseUrl + '/Registration/checkuserexist?userMobileNo=' + mobileNo)
//       .map(res => res.json());
//   }

//   /**
//    * Register new user
//    */
//   registerUser(userData: Registration) {
//     console.log("Registration data:", JSON.stringify(userData));
//     return this._http.post(this.BaseUrl + '/Registration/register_v2', userData)
//       .map(res => res.json());
//   }

// }


// WEBPACK FOOTER //
// ./src/app/login/services/login.service.ts